<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <span>{{data['item'][data.field.key] | formatoFecha}}</span>
  </div>

</template>

<script>

    export default {
        name: "BandejaFechaComponente",
        props: {
            data: Object
        },
      data: () => ({
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
      }),
      created(){
        this.debug = this.$localStorageService.getDebug();
      },
    }

</script>
